// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.dialogue-container {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialogue-container .dialogue-message-container {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background: #D1D3D4;
  padding: 20px;
  width: 60%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.dialogue-container .dialogue-message-container .dialogue-message1 {
  font-size: 1.4rem;
  font-weight: bolder;
  text-decoration: underline;
  text-align: center;
}
.dialogue-container .dialogue-message-container .dialogue-message2 {
  padding-top: 25px;
  font-size: 1.2em;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SimpleDialog.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAIJ;AAFI;ECNA,mBDOuC;ECcvC,2CAAA;EDZI,mBDaA;ECZA,aAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAIR;AAFQ;EACI,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AAIZ;AAFQ;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;AAIZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
